import { motion } from "framer-motion";

export default function HeroBlock() {
  return (
    <section className="relative min-h-screen w-full flex items-start md:items-center justify-center overflow-hidden pt-24 md:pt-0">

      <motion.img
        src="/img/quienesSomos/slider.jpeg"
        alt="Profesionales confiables"
        className="absolute inset-0 w-full h-full object-cover brightness-60"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 14, ease: "easeOut" }}
      />

      <div className="absolute inset-0 bg-black/60" />

      <motion.div
        className="relative z-10 max-w-4xl text-center px-6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
        <h1 className="text-4xl md:text-6xl font-serif text-white mb-6 leading-tight">
          Creemos en un mundo donde confiar sea sencillo
        </h1>

        <p className="text-lg md:text-xl text-gray-200">
          Conectamos talento certificado con personas que buscan
          excelencia, confianza y resultados reales.
        </p>
      </motion.div>
    </section>
  );
}
